module.exports = __webpack_public_path__ + "img/the-netherlands-genitourinary-diseases-female.9b8ce0db.png";